/* eslint-disable */
export default {
  toolTip: '在 {crmName} 中查看',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
